const importResource = (resource, language, staticsBaseUrl) =>
  fetch(`${staticsBaseUrl}assets/locale/${resource}_${language}.json`).then(res => res.json())

export const importResources = async (resources: string[], language: string, staticsBaseUrl: string) =>
  (await Promise.all(resources.map(resource => importResource(resource, language, staticsBaseUrl)))).reduce(
    (ret: object, translation: object) => ({...ret, ...translation}),
    {},
  )
